import Dropzone from 'dropzone';

Dropzone.createElement = function(string) {
    const el = $(string);
    return el[0];
};

export { Dropzone };